export default __webpack_public_path__ + "static/media/acconMap.2b734d3e.png";